<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <router-link
                                            :to="{ name: 'Jobs' }"
                                            target="_blank"
                                            class="btn btn-primary mr-2"
                                            v-b-tooltip.hover
                                            title="Job Posting"
                                        >
                                            <i class="mdi mdi-open-in-new"></i>
                                        </router-link>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.company') }}
                                                </label>
                                                <multiselect
                                                    v-model="companyFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="companyDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.department') }}
                                                </label>
                                                <multiselect
                                                    v-model="departmentFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="departmentDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.office') }}
                                                </label>
                                                <multiselect
                                                    v-model="officeFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="officeDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Intern
                                                </label>
                                                <multiselect
                                                    v-model="isInternFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="yesNoDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Fresh Graduate
                                                </label>
                                                <multiselect
                                                    v-model="isFreshGraduateFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="yesNoDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Published
                                                </label>
                                                <multiselect
                                                    v-model="isPublishedFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="yesNoDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(name)="data">
                                    <div class="d-flex align-items-center">
                                        <div class="avatar-xs mr-2">
                                            <span
                                                :class="[
                                                    'avatar-title rounded-circle font-size-14',
                                                    `bg-soft-${avatarColor(data.item.name)}`,
                                                    `text-${avatarColor(data.item.name)}`
                                                ]"
                                            >
                                                {{ data.item.name ? data.item.name.charAt(0).toUpperCase() : '-' }}
                                            </span>
                                        </div>
                                        <span>{{ data.item.name || '--' }}</span>
                                    </div>
                                </template>
                                <template #cell(company)="data">
                                    <CompanyLink :company="data.item.company" fallback="--" />
                                </template>
                                <template #cell(department)="data">
                                    <span>{{ data.item.department ? data.item.department.name : '--' }}</span>
                                </template>
                                <template #cell(office)="data">
                                    <span>{{ data.item.office ? data.item.office.name : '--' }}</span>
                                </template>
                                <template #cell(closingDate)="data">
                                    <span>{{ data.item.closingDate || '--' }}</span>
                                </template>
                                <template #cell(openings)="data">
                                    <b-badge :variant="data.item.openings == 0 ? 'secondary' : 'primary'">
                                        {{ data.item.openings }}
                                    </b-badge>
                                </template>
                                <template #cell(published)="data">
                                    <i :class="data.item.isPublished ? 'text-info mdi mdi-checkbox-marked-circle' : 'text-muted mdi mdi-close-circle'"></i>
                                </template>
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info mr-1"
                                        v-b-tooltip.hover
                                        title="Duplicate Job"
                                        @click.stop="openDuplicateForm(data.item)"
                                    >
                                        <i class="mdi mdi-content-copy font-size-18"></i>
                                    </a>
                                    <a
                                        :href="tableRows[data.index].isPublished ? $router.resolve({name: 'Jobs', query: { id: data.item.uuid }}).href : null"
                                        :target="tableRows[data.index].isPublished ? '_blank' : null"
                                        rel="noopener noreferrer"
                                        :class="[
                                            'mr-1',
                                            tableRows[data.index].isPublished ? 'text-info cursor-pointer' : 'text-muted cursor-default']"
                                        v-b-tooltip.hover
                                        :title="tableRows[data.index].isPublished ? 'Job Posting' : 'Not Published'"
                                        @click.stop
                                    >
                                        <i class="mdi mdi-open-in-new font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="candidate-job-form"
            :title="$t(candidateJob.uuid ? 'label.updateX' : 'label.createX', [$t('module.job')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
            size="lg"
        >
            <b-container fluid>
                <CandidateJobForm
                    :candidateJobUUID="candidateJob.uuid"
                    :candidateJobName="candidateJob.name"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="candidateJobForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="candidate-job-delete"
            :title="candidateJob.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ candidateJob.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('candidate-job-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ candidateJob.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { candidateJobMethods, lookupMethods } from "@/state/api";
import { CANDIDATE_JOB_MODULE } from "@/state/api/candidateJob.state";
import CandidateJobForm from "@/views/pages/admin/candidateJob/candidateJobForm";

export default {
    components: { Multiselect, CandidateJobForm },
    async created() {
        await this.lookupCompany({});
        await this.lookupDepartment();
        await this.lookupOffice({});

        sessionHelper.clearSearch(SESSION.CANDIDATE_JOB_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            yesNoDdl: [
                { value: 'all', text: i18n.t('label.all') },
                { value: 1, text: 'Yes' },
                { value: 0, text: 'No' },
            ],
            companyFilter: null,
            departmentFilter: null,
            officeFilter: null,
            isInternFilter: null,
            isFreshGraduateFilter: null,
            isPublishedFilter: null,
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'company', label: i18n.t("module.company"), sortable: true, class: 'text-nowrap' },
                { key: 'department', label: i18n.t("module.department"), sortable: true, class: 'text-nowrap' },
                { key: 'office', label: i18n.t("module.office"), sortable: true, class: 'text-nowrap' },
                { key: 'closingDate', label: "Closing Date", sortable: true, class: 'text-nowrap' },
                { key: 'openings', label: "Openings", sortable: true, class: 'text-nowrap' },
                { key: 'published', label: "Published", sortable: true, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            candidateJob: {
                uuid: "",
                name: "",
                isActive: false,
            },
            loading: true,
        };
    },
    methods: {
        ...candidateJobMethods,
        ...lookupMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.CANDIDATE_JOB_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CANDIDATE_JOB_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getCandidateJobList(this.searchCriteria);
        },
        getCandidateJobList(filter) {
            this.getAllCandidateJob({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.CANDIDATE_JOB_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.CANDIDATE_JOB_SEARCH);
            filter.pageNumber = pageNumber;
            this.getCandidateJobList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }

            if (this.companyFilter?.value == 1)
                delete this.searchCriteria.companyUUID;
            else if (this.companyFilter?.value)
                this.searchCriteria.companyUUID = this.companyFilter.value;

            if (this.departmentFilter?.value == 1)
                delete this.searchCriteria.departmentUUID;
            else if (this.departmentFilter?.value)
                this.searchCriteria.departmentUUID = this.departmentFilter.value;

            if (this.officeFilter?.value == 1)
                delete this.searchCriteria.officeUUID;
            else if (this.officeFilter?.value)
                this.searchCriteria.officeUUID = this.officeFilter.value;

            if (this.isInternFilter?.value == 'all')
                delete this.searchCriteria.isIntern;
            else if (this.isInternFilter?.value == 0 || this.isInternFilter?.value == 1)
                this.searchCriteria.isIntern = this.isInternFilter.value;

            if (this.isFreshGraduateFilter?.value == 'all')
                delete this.searchCriteria.isFreshGraduate;
            else if (this.isFreshGraduateFilter?.value == 0 || this.isFreshGraduateFilter?.value == 1)
                this.searchCriteria.isFreshGraduate = this.isFreshGraduateFilter.value;

            if (this.isPublishedFilter?.value == 'all')
                delete this.searchCriteria.isPublished;
            else if (this.isPublishedFilter?.value == 0 || this.isPublishedFilter?.value == 1)
                this.searchCriteria.isPublished = this.isPublishedFilter.value;

            this.getCandidateJobList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.candidateJob = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('candidate-job-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.candidateJob.uuid,
                isActive: this.candidateJob.isActive == 0 ? 1 : 0,
            };
            this.updateCandidateJobStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('candidate-job-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.candidateJob = {
                    uuid: data.uuid,
                    name: "",
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('candidate-job-form');
            });
        },
        openDuplicateForm(data) {
            this.candidateJob = {
                uuid: "",
                name: data.name,
                isActive: false,
            };
            this.$nextTick(() => {
                this.$bvModal.show('candidate-job-form');
            });
        },
        closeForm() {
            this.candidateJob = {
                uuid: "",
                name: "",
                isActive: false,
            };
            this.$bvModal.hide('candidate-job-form');
        },
        avatarColor(item) {
            const colors = ['primary', 'success', 'danger', 'warning', 'info'];
            if (!item) return 'secondary';
            return colors[item.length % colors.length];
        },
    },
    computed: {
        ...mapState(CANDIDATE_JOB_MODULE, ['status']),
        companyDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.companyDdl,
            ];
        },
        departmentDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.departmentDdl,
            ];
        },
        officeDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.officeDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.candidateJob.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.candidateJob.list.pagination.total || 0;
        },
    },
}
</script>
